import { UnitResponse } from 'utils/api/modules/units/units.types';

export interface OrgUnit extends UnitResponse {
  children: OrgUnit[];
}

export const isIntake = (unit: Pick<OrgUnit, 'kind'> | null | undefined): boolean => unit?.kind === 'intake';
